export function hostnameFromLandingUrl(url: string): string {
	try {
		return new URL(url).hostname;
	} catch {
		return url;
	}
}

const HOSTNAME_RE = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i;

export function isValidLandingZoneName(value: string): boolean {
	return HOSTNAME_RE.test(value);
}

const SUBDOMAIN_RE = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export function isValidLandingSubdomain(value: string): boolean {
	return SUBDOMAIN_RE.test(value);
}
